import GroupIcon from '@material-ui/icons/ViewList';

import GroupList from './GroupList';
import GroupCreate from './GroupCreate';
import GroupEdit from './GroupEdit';

export default {
  list: GroupList,
  create: GroupCreate,
  edit: GroupEdit,
  icon: GroupIcon,
};
